import React from "react";

/**
 * Landing page pública de marketing.
 * Serve o HTML autossuficiente enviado pelo cliente (CSS/JS/base64 embutidos)
 * dentro de um iframe full-screen, preservando 100% do layout, animações e
 * imagens — sem conflitar com o CSS/JS do app. Os botões "Entrar"/"Começar
 * grátis" dentro do HTML usam target="_top" e apontam para /login e /signup.
 */
export default function MarketingLanding() {
  return (
    <iframe
      title="Clean Manager USA"
      src="/clean-manager-usa.html"
      data-testid="marketing-landing"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
        margin: 0,
        padding: 0,
      }}
    />
  );
}
